import React from 'react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';

import {
	QueryClient,
	QueryClientProvider
} from 'react-query';
import { AuthContextProvider } from './store/auth-context';
import { AccessibilityProvider } from './store/accesibility-context';
import { Provider } from 'react-redux';

import store from './store/index';
import { ChatIdProvider } from './store/chat-id-context';
import { API_CONSTANTS } from './api/apiConstants';

Sentry.init({
	dsn: 'https://b7c20eec2910bb03d8125a243dac6bae@o4508535982587904.ingest.us.sentry.io/4508542093361152',
	integrations: [],
	environment: API_CONSTANTS.API_ENV,
});

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById('root')).render(
	<React.StrictMode>
		<Provider store={store}>
			<AuthContextProvider>
				<AccessibilityProvider>
					<ChatIdProvider>
						<QueryClientProvider client={queryClient}>
							<App />
						</QueryClientProvider>
					</ChatIdProvider>
				</AccessibilityProvider>
			</AuthContextProvider>
		</Provider>
	</React.StrictMode>
);
